
import axios from 'axios'
import { instance } from '../utils/http.js';
import uhiddenUtil from '@/utils/uhiddenUtil';

export const Customdrag_URL = 'https://js.sitestar.cn/ajax/members.ashx?module=Customdrag';
const BASE_URL = 'https://js.sitestar.cn/ajax/members.ashx';
const BASE_USERHOME_URL = 'https://js.sitestar.cn/ajax/userhome.ashx';
const BASE_ORDER_URL = 'https://js.sitestar.cn/ajax/order.ashx'
const BASE_OPERATE_URL = 'https://js.sitestar.cn/ajax/operate.ashx';

// export const Customdrag_URL = 'http://localhost:58315/ajax/members.ashx?module=Customdrag';
//  const BASE_URL = 'http://localhost:58315/ajax/members.ashx';
//  const BASE_USERHOME_URL = 'http://localhost:58315/ajax/userhome.ashx';
//  const BASE_ORDER_URL = 'http://localhost:58315/ajax/order.ashx'
//  const BASE_OPERATE_URL = 'http://localhost:58315/ajax/operate.ashx'


// 获取手机验证码
export const getSmsCode = (phone, uhidden) => {
  return axios.get(BASE_URL, {
    params: {
      module: 'Getcode',
      umbl: phone,
      uhidden,
    },
  });
};

// 获取 token
export const getToken = (uhidden) => {
  return axios.get(BASE_URL, {
    params: {
      module: 'Getfmtoken',
      uhidden,
    },
  });
};

// 注册
export const register = (params) => {
  return axios.post(BASE_URL, null, {
    params: Object.assign({
      module: 'Reg'
    }, params)
  });
};

// 登录
export const login = ({ usertype, unme, upss, phonecode, uhidden, fmtoken }) => {
  return axios.post(BASE_URL, null, {
    params: {
      module: 'Login',
      usertype,   // 0: 密码登录, 1: 短信验证码登录
      unme,       // 用户名（手机号或账号）
      upss,       // 密码（仅密码登录时需要）
      phonecode,  // 验证码（仅短信登录时需要）
      uhidden,    // 验证串
      fmtoken     // token
    }
  });
};

// 退出系统
export const logout = () => {
  return instance.get(BASE_URL, {
    params: {
      module: 'Logout'
    }
  });
};

// 获取订单列表
export const getOrderList = (params = {}) => {
  return instance.get(BASE_USERHOME_URL, {
    params: Object.assign({
      module: 'GetList',
    }, params),
  });
};

/**
 * 获取建站编辑地址
 * @param {Object} params - 包含 uhidden、fmtoken、nme
 */
export const getSiteEditUrl = (params) => {
  return axios.get(BASE_USERHOME_URL, {
    params: Object.assign({
      module: 'GetSiteEditUrl',
    }, params),
  });
};

/**
 * 获取用户信息
 * @param {Object} params - 包含 uhidden
 */
export const getUnmeInfo = () => {
  return instance.get(BASE_USERHOME_URL, {
    params: {
      module: 'GetUnmeInfo'
    },
  });
};

/**
 * 获取用户优惠券列表
 */
export const getTickList = (opttype,proprd) => {
  return instance.get(BASE_USERHOME_URL, {
    params: {
      module: 'GetTickList',
      opttype, 
      proprd
    },
  });
};

/**
 * 获取建站管理地址
 * @param {Object} params - 包含 uhidden、fmtoken、nme
 */
export const getSiteManagerUrl = (params) => {
   return axios.get(BASE_USERHOME_URL, {
    params: Object.assign({
      module: 'GetSiteManagerUrl',
    }, params),
  });
};

/**
 * 获取验证码图片地址（用于 <img :src="..." />）
 * 每次调用返回一个不同时间戳避免缓存
 */
export const getCaptchaImageUrl = () => {
  return `https://js.sitestar.cn/GenerateCheckCode.aspx?t=${Date.now()}`;
};

// 提交咨询信息
export const feedbackSubmit = (mobile,smscode,businesstype,usrname,uhidden,fmtoken) => {
  return axios.get(BASE_OPERATE_URL, {
    params: {
      module: 'FeedbackSubmit',
      mobile,   // 手机号
      smscode,       // 短信验证码
      businesstype,       //公司名称
      usrname,  // 姓名
      uhidden,    // 验证串
      fmtoken     // token
    },
  });
};

/**
 * 获取外链地址（我的账户 / 交易记录）
 * 使用带 10s 超时与拦截器的 instance（此前裸 axios 无超时）
 */
export const getOutUrl = (uhidden, outtag, pronme='', temid='') => {
  return instance.get(BASE_USERHOME_URL, {
    params: {
      module: 'GetOutUrl',
      uhidden: uhidden,
      outtag: outtag,
      pronme:pronme,
      temid:temid
    }
  });
};

/**
 * 获取机房列表
 */
export const getPlaceList = (uhidden) => {
  return axios.get(BASE_URL, {
    params: {
      module: 'GetPlaceList',
      uhidden: uhidden
    }
  });
};

/**
 * 获取价格列表
 * @param {string} type - 机房类型（例如：'cn' 或 'hk'）
 */
export const getBuyPriceList = (uhidden,type) => {
  return axios.get(BASE_URL, {
    params: {
      module: 'GetBuyPriceList',
      type: type,
      uhidden: uhidden
    }
  });
};

/**
 * 获取所有购买价格列表
 */
export const getAllBuyPriceList = (uhidden) => {
  return axios.get(BASE_URL, {
    params: {
      module: 'GetAllJsPriceList',
      uhidden: uhidden
    }
  });
};

/**
 * 获取服务页产品配置
 */
export const GetJsServicePagePro = (uhidden) => {
 // console.info("GetJsServicePagePro");
    return axios.get(BASE_URL, {
    params: {
      module: 'GetJsServicePagePro',
      uhidden: uhidden
    }
  });

};


// 免费开通模板
export function openFreeService({uhidden, tplid }) {
  return axios.post(BASE_ORDER_URL, null, {
    params: {
      module: 'OpenFree',
      uhidden,
      tplid
    }
  })
}

export function openFreeServiceShowLoading({uhidden, tplid }) {
  return instance.post(BASE_ORDER_URL, null, {
    params: {
      module: 'OpenFree',
      uhidden,
      tplid
    }
  })
}

// 订阅收费模板
export function subscribeService({uhidden, tplid, year, type, tkid }) {
  return axios.post(BASE_ORDER_URL, null, {
    params: {
      module: 'Subscribe',
      uhidden,
      tplid,
      year,
      type,
      tkid
    }
  })
}

// 开通收费模板付款
export function payProService({uhidden, upay, zpay }) {
  return axios.post(BASE_ORDER_URL, null, {
    params: {
      module: 'PayPro',
      uhidden,
      upay,
      zpay
    }
  })
}

//获取续费价格列表
export const getRenewList = (type) => {
  return axios.get(BASE_URL, {
    params: {
      module: 'GetRenewList',
      type: type
    }
  });
};

//提交续费
export const submitRenew = ({uhidden, pdtnme, year, totalmoney,tkid}) => { 
    return axios.post(BASE_ORDER_URL, null, {
    params: {
      module: 'Renew',
      uhidden,
      pdtnme,
      year,
      totalmoney,
      tkid
    }
  })
};

//获取升级价格
export const getUpgradePrice = (uhidden, pdtnme, newprd) => {
      return instance.post(BASE_ORDER_URL, null, {
    params: {
      module: 'GetUpgradePrice',
      uhidden,
      pdtnme,
      newprd
    }
  })
};

//提交升级
export const submitUpgrade = ({uhidden, pdtnme, prd, totalmoney,nyear,tkid}) => {

      return axios.post(BASE_ORDER_URL, null, {
    params: {
      module: 'Upgrade',
      uhidden,
      pdtnme,
      prd,
      totalmoney,
      nyear,
      tkid
    }
  })
};

// 续费 / 升级支付
export const payForUpgradeOrRenew = ({uhidden, upay, parmid}) => {

        return axios.post(BASE_ORDER_URL, null, {
    params: {
      module: 'UprenewPay',
      uhidden,
      upay,
      parmid
    }
  })
};


//获取赠送邮箱
export const GetFreeMail = (domainname,pronme) => {
  return axios.get(BASE_USERHOME_URL, {
    params: {
      module: 'OpenFreeMail',
      domainname: domainname,
      pronme: pronme
    }
  });
};





// WEBPACK FOOTER //
// ./src/api/user.js